import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const peopleNewStaffWidget: DashboardWidgetConfiguration = {
  widgetId: "people.new-staff",
  name: "New staff",
  description: "Employment records started in the selected period.",
  apps: [
    "appointments",
    "asset",
    "attendance",
    "configuration",
    "contracts",
    "crm",
    "document",
    "expenses",
    "field-service",
    "finance",
    "help-desk",
    "home",
    "hr",
    "integrations",
    "inventory",
    "invoicing",
    "maintanance",
    "manufacturing",
    "payroll",
    "point-of-sale",
    "procurement",
    "project",
    "recruitment",
    "rental",
    "sales",
    "schedule-planning",
    "subscriptions",
    "time-off",
    "timesheets",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "hr.employments",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "employment_id",
          as: "new_staff",
        },
      ],
    },
  },
  inputs: {
    label: "New staff",
    subtext: "started in the last 30 days",
    icon: "users",
    color: "purple",
  },
  dummyData: {
    value: 24,
    subtext: "new team members",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
